import PublicFacingLandingPage from './PublicFacingLandingPage';

export default PublicFacingLandingPage;
